export const plural = (number, words) => {
    return Math.abs(parseInt(number, 10)) === 1 ? words[0] : words[1];
};

export const locale = {
    //staticConfigsLoader
    "StaticConfigLoader.caption.error": "Błąd inicjalizacji",
    "StaticConfigLoader.caption.init": "Inicjalizacja",
    "StaticConfigLoader.text.init": "Inicjalizacja aplikacji...",
    "StaticConfigLoader.error.settings": "Nie można wczytać ustawień strony",
    "StaticConfigLoader.error.circuits": "Nie można wczytać konfiguracji usług",
    //app
    "Legal.Localization": "pl",
    "AchievementApp.Navbar.storeTitle": "Sklep",
    "AchievementApp.Navbar.supportTitle": "Wsparcie",
    "Legal.TermsConditions": "Regulamin",
    "Legal.TermsService": "Warunki świadczenia usług",
    "Legal.PrivacyPolicy": "Polityka prywatności",
    "Legal.CookiesPolicy": "Ustawienia plików cookie",
    "Legal.Copyright": "Wszystkie znaki towarowe, loga i nazwy handlowe są własnością odpowiednich właścicieli.",
    "AchievementApp.Navbar.achievement": "Osiągnięcie osobiste",
    "AchievementApp.Navbar.userAchievement": "Osiągnięcie użytkownika",
    "AchievementApp.Navbar.settingsLink": "Ustawienia",
    "AchievementApp.Navbar.profileLink": "Profil",
    "AchievementApp.Navbar.reloginLink": "Zaloguj się ponownie lub zmień konto",
    "AchievementApp.Navbar.pageTitlePrew": "Osiągnięcia ",
    "AchievementApp.Navbar.pageTitle": "aijin.Net",
    //commonAssets
    "ViewItemDetailed.state.completed": "Ukończono",
    //marketAppFilterEditor
    "AppFilterEditor.label.byTitles": "Filtruj wg tytułów",
    //userFriendsList
    "UserFriendsList.heading.myFriends": "Moi znajomi",
    "UserFriendsList.heading.showMore": "Pokaż więcej",
    //credentialsIcon
    "LimitedAccountPanel.2step.reason": "Musisz skonfigurować uwierzytelnianie dwuetapowe",
    "LimitedAccountPanel.2step.link": "Więcej informacji na temat uwierzytelniania dwuetapowego",
    "LimitedAccountPanel.2step.href": "https://support.gaijin.net/hc/en-us/articles/203623622-How-to-set-up-the-Two-Step-Authorization-Google-Authenticator-",
    "LimitedAccountPanel.email.reason": "Musisz potwierdzić swój adres e-mail",
    "LimitedAccountPanel.email.link": "Przejdź do profilu",
    "LimitedAccountPanel.email.href": "https://store.gaijin.net/user.php",
    "LimitedAccountPanel.title": "Na twoje konto nałożono ograniczenia z powodu:",
    "LimitedAccountPanel.conclusion": "Po zmianie ustawień bezpieczeństwa musisz się wylogować, a następnie ponownie zalogować, by zmiany zaczęły obowiązywać",
    "LimitedAccountPanel.relogin": "Zaloguj się ponownie",
    "EmailVerificationStateIcon.success": "Konto potwierdzone, adres e-mail zweryfikowany",
    "EmailVerificationStateIcon.warning": "Konto niepotwierdzone, adres e-mail niezweryfikowany",
    "EmailVerificationStateIcon.danger": "Konto niepotwierdzone, WYMAGANA jest weryfikacja adresu e-mail",
    "TwoFactorStateIcon.success": "Konto zabezpieczone za pomocą uwierzytelniania dwuetapowego",
    "TwoFactorStateIcon.warning": "Konto nie jest bezpieczne. Uwierzytelnianie dwuetapowe zostało wyłączone",
    "TwoFactorStateIcon.danger": "WYMAGANE jest uwierzytelnianie dwuetapowe",
    //userSettingsDialog
    "UserSettingDialog.saveSettings": "Zapisz ustawienia",
    "UserSettingDialog.settings": "Ustawienia",
    "UserSettingDialog.userSettings": "Ustawienia użytkownika",
    "UserSettingDialog.language": "Język",
    "UserSettingDialog.privacy": "Prywatność",
    "UserSettingDialog.allUsers": "Wszyscy użytkownicy",
    "UserSettingDialog.friendsOnly": "Tylko znajomi",
    "UserSettingDialog.onlyMe": "Tylko ja",
    "UserSettingDialog.whoCanView": "Kto może oglądać moje osiągnięcia",
    //unlockProgress
    "ViewUnlockProgress.of": " z ",
    "ViewUnlockProgress.achievCompleted": " Zdobyte osiągnięcia:",
    "ViewUnlockProgress.myUnlock": "Moje osiągnięcia",
    //userSearchFilter
    "ViewItemSearch.termsPlaceholder": "Szukaj po pseudonimie",
    "ViewItemSearch.label.search": "Szukaj użytkowników",
    "ViewItemSearch.resultNotFound": "Nie odnaleziono użytkownika",
    //achievementAssets
    "ViewItemSearch.heading.resultsFor": "Osiągnięcie",
    "ViewItemSearch.stub.empty": "Brak osiągnięć",
    "ViewItemSearch.stub.emptyCompare_1": "Użytkownik ",
    "ViewItemSearch.stub.emptyCompare_2": " nie ma osiągnięć w tej grze",
    "ViewItemSearch.limitedAccess": "Dostęp do osiągnieć wybranego użytkownika jest ograniczony",
    "ViewItemSearch.heading.selectGame": "Wybierz grę z listy",
    "ViewItemSearch.globalstat.opened": "odblokowane przez: ",
    "ViewItemSearch.globalstat.ofGamers": "% graczy",
    //authentication
    "NotAllowedMessage.caption": "Niedozwolone",
    "NotAllowedMessage.body.h1": "Dostęp do osiągnięć",
    "NotAllowedMessage.body.h3": "obecnie jest niedozwolone dla twojego konta",
    "NotAllowedMessage.relogin": "Zmień konto",
    "LandingMessage.caption": "Uwierzytelnienie",
    "LandingMessage.body": "Kończenie lądowania...",
    "TokenExpiredMessage.caption": "Uwierzytelnienie wygasło",
    "TokenExpiredMessage.body.h3": "My nie możemy z tym zrobić zbyt wiele, ale ty możesz",
    "TokenExpiredMessage.relogin": "Zaloguj się ponownie",
    "AuthErrorMessage.caption": "Uwierzytelnienie nieudane",
    "AuthErrorMessage.body.h1": "Nieudane sprawdzanie uwierzytelnienia",
    "AuthErrorMessage.body.code": "Kod",
    "AuthErrorMessage.body.desc": "My nie możemy z tym zrobić zbyt wiele, ale ty możesz",
    "AuthErrorMessage.relogin": "Zaloguj się ponownie",
    "AuthorizationRequiredMessage.caption": "Wymagane uwierzytelnienie",
    "AuthorizationRequiredMessage.body.h3.1": "Wchodzisz na",
    "AuthorizationRequiredMessage.body.h3.2": "Gaijin Achievements",
    "AuthorizationRequiredMessage.body.h3.3": "By przejść dalej, potrzebujesz upoważnienia",
    "AuthorizationRequiredMessage.login": "Zaloguj się na Gaijin.Net",
    "CheckingAuthMessage.caption": "Uwierzytelnienie",
    "CheckingAuthMessage.body": "Sprawdzanie uwierzytelnienia, proszę czekać",
    "AuthorizationRequiredMessageMobile.body.h3.1": "Wersja mobilna jest czasowo niedostępna",
    "AuthorizationRequiredMessageMobile.body.h3.2": "Skorzystaj z wersji komputerowej",
    "AuthorizationRequiredMessageMobile.body.h3.3": "Przepraszamy",
}